import { uploadedDocumentsStaticService } from '../../../services';

export const config: any = {
  getUploadedDocumentsStatic: (token: string) =>
    uploadedDocumentsStaticService.getStaticUploadedDocuments(token),
};
